import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Link, Typography } from '@mui/material';
import { JBColors, JBIcon } from '@bjb-gcrm/gcrm-frontend-components';
import { LightTooltip } from 'components/Common/LightTooltip';

// TODO: replace the temporary link (given by BA) once a new one is provided by Financial Crime Compliance. To be covered under: https://jira.sehlat.io/browse/GCFP-14545
const BLOCKING_INSTRUCTION_PAGE_URL =
  'https://intranet.juliusbaer.com/global-compliance/sanctionsembargos/Pages/default.aspx';

export type BlockingInstructionTagProps = {
  isSecret: boolean;
};

export const BlockingInstructionTag = ({ isSecret }: BlockingInstructionTagProps) => {
  const { t } = useTranslation();

  const variant = isSecret ? 'secret' : 'known';
  const label = isSecret
    ? t('accounts.tabs.blockingInstructions.blocked.secretLabel')
    : t('accounts.tabs.blockingInstructions.blocked.label');
  const tooltipText = (
    <Link href={BLOCKING_INSTRUCTION_PAGE_URL} target="_blank" color="inherit" underline="hover">
      {t(`accounts.tabs.blockingInstructions.blocked.${variant}Tooltip`)} <JBIcon iconName="deeplink" size="sm" />
    </Link>
  );

  return (
    <LightTooltip title={tooltipText} data-testid="br-blocked-tag-tooltip" arrow>
      <Box display="flex" alignItems="center" gap={0.5} sx={{ flexShrink: 0 }} data-testid="br-blocked-tag">
        <Typography variant="h1" sx={{ textTransform: 'none', whiteSpace: 'nowrap' }} color={JBColors.support.red[100]}>
          {label}
        </Typography>
      </Box>
    </LightTooltip>
  );
};
